// client/src/modules/quoting/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Quoting module manifest (P2)
 *
 * Quote creation, pricing, PDF generation, and approvals.
 * Fully migrated to module registry with lazy-loaded routes.
 */
export const quotingModule: ModuleManifest = {
  id: 'P2',
  name: 'Quoting',
  shortName: 'Quoting',
  description: 'Quote creation, pricing, PDF generation, and approvals',
  icon: '📝',
  status: 'live',
  urlPrefix: '/quoting',
  routes,
  navItems,
};

export default quotingModule;
